<div class="component-main-container">
  <div class="header">
    <app-page-header pageTitle="{{ 'alerts.alerts-title-label' | translate }}"
      parentTitle="{{ 'alerts.alerts-parent-label' | translate }}">
    </app-page-header>
  </div>

  <div class="row">
    <!-- Form Div -->
    <div class="col-lg-5 col-xl-4 col-md-12">
      <!-- Filtrar registro de alerta -->
      <div class="component-forms-box">
        @if (!isEditingAlert) {
        <div class="form-fields-box" [formGroup]="filterForm" [ngClass]="!filter ? 'closed' : ''">
          <h2 (click)="filterBox()">
            {{ "alerts.form-filter-alerts" | translate }}
          </h2>
          <hr [ngClass]="!filter ? 'hr-open' : ''" />
          <!-- Campo de busca de instalação -->
          @if (filterForm.get('alertsType')?.value !== null) {
          <div class="form-step">
            <app-circle-number stepNumber="1"></app-circle-number>
            <mat-form-field appearance="outline">
              <mat-label>{{ "alerts.form-filter-search-installation" | translate }}
              </mat-label>
              <input matInput formControlName="installationSearch" #installationReference />
              <mat-icon class="component-search-icon" (click)="
                  filterInstallationsByReference(installationReference.value)
                " svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>
          }
          @if (isLoadingInstallation) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }
          <!-- Campo de seleção de instalação -->
          @if (installationList.length > 0 && isFieldVisible) {
          <div class="form-step">
            <app-circle-number stepNumber="1.1" (isSubstep)="(true)"></app-circle-number>
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>{{
                "alerts.form-filter-installation" | translate
                }}</mat-label>
              <mat-select formControlName="installationReferenceSelected">
                <mat-option [value]="">
                  {{ "alerts.form-nothing" | translate }}
                </mat-option>
                @for (installation of installationList; track installation) {
                <mat-option [value]="installation.installationReference">
                  {{ installation.installationReference }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
          @if (installationList.length > 0 && !isFieldVisible) {
          <div class="form-step">
            <app-circle-number stepNumber="1.1" (isSubstep)="(true)"></app-circle-number>
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>{{
                "alerts.form-filter-installation" | translate
                }}</mat-label>
              <mat-select formControlName="installationSelectedId">
                <mat-option [value]="">
                  {{ "alerts.form-nothing" | translate }}
                </mat-option>
                @for (installation of installationList; track installation) {
                <mat-option [value]="installation.installationId">
                  {{ installation.installationReference }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
          <!-- Campo data -->
          @if (filterForm.get('alertsType')?.value === 'ALERTS_EQUIPMENT') {
          <div class="form-step">
            <app-circle-number stepNumber="2"></app-circle-number>
            <div class="date-picker-input">
              <p-datepicker inputId="calendar-24h" selectionMode="range" formControlName="alertDateTime" appendTo="body"
                [showTime]="true" [hourFormat]="timeRange" placeholder="Intervalo de datas" showIcon iconDisplay="input"
                dateFormat="dd/mm/yy" />
            </div>
          </div>
          }
          @if (filterForm.get('alertsType')?.value === 'ALERTS') {
          <div class="form-step">
            <app-circle-number stepNumber="2"></app-circle-number>
            <div class="date-picker-input">
              <p-datepicker inputId="calendar-24h" selectionMode="range" formControlName="alertDateTime" appendTo="body"
                [showTime]="true" [hourFormat]="timeRange" placeholder="Intervalo de datas" showIcon iconDisplay="input"
                dateFormat="dd/mm/yy" />
            </div>
          </div>
          }

          <!-- Campo status -->
          @if (
          isFieldVisible && filterForm.get('alertsType')?.value !== null
          ) {
          <div class="form-step">
            <app-circle-number stepNumber="3"></app-circle-number>
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>
                {{"alerts.form-filter-alert-state" | translate}}
              </mat-label>
              <mat-select formControlName="alertState" name="alertState">
                <mat-option [value]="">{{
                  "alerts.form-nothing" | translate
                  }}</mat-option>
                <mat-option value="ALERTA">
                  {{"alerts.form-filter-alert-state-alerting" | translate}}
                </mat-option>
                <mat-option value="NORMALIZADO">
                  {{"alerts.form-filter-alert-state-normalized" | translate}}
                </mat-option>
                <!--mat-option value="SEM_COMUNICACAO">
                  {{"alerts.form-filter-alert-state-no-communication" | translate}}
                </mat-option-->
              </mat-select>
            </mat-form-field>
          </div>
          }
          @if (
          !isFieldVisible && filterForm.get('alertsType')?.value !== null
          ) {
          <div class="form-step">
            <app-circle-number stepNumber="3"></app-circle-number>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "alerts.form-filter-search-gateway" | translate }}
              </mat-label>
              <input formControlName="gatewaySearch" matInput #gatewayReference />
              <mat-icon class="component-search-icon" (click)="filterGatewaysByReference(gatewayReference.value)"
                svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>
          }
          <!-- Campo de seleção de gateway -->
          @if (gatewayList.length > 0) {
          <div class="form-step">
            <app-circle-number stepNumber="3.1" (isSubstep)="(true)"></app-circle-number>
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>{{ "alerts.form-filter-select-gateway" | translate }}
              </mat-label>
              <mat-select formControlName="gatewaySelected">
                @for (gateway of gatewayList; track gateway) {
                <mat-option [value]="gateway.id">
                  {{ gateway.reference }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
          @if (isLoadingGateway) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }
          <!-- Campo regra de alerta -->
          @if (
          filterForm.get('alertsType')?.value === 'ALERTS'
          ) {
          <div class="form-step">
            <app-circle-number stepNumber="4"></app-circle-number>
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>{{
                "alerts.form-filter-alert-rule" | translate
                }}</mat-label>
              <mat-select formControlName="alertCode">
                @if (loadingAlertRules$ | async) {
                <mat-progress-bar mode="indeterminate">
                </mat-progress-bar>
                }
                <mat-option [value]="">{{
                  "alerts.form-nothing" | translate
                  }}</mat-option>

                <!-- Verifica a empresa selecionada para exibir as regras de alerta específicas para a Iluminação
                Paulistana -->
                @if(company !=='Q29tcGFueToxNg==') {

                @for (alertRule of alertRules; track alertRule) {
                <mat-option [value]="alertRule.code">
                  {{ alertRule.description }}
                </mat-option>
                }
                }@else {
                @for (alertRule of alertsRulesIluminaSP; track alertRule) {
                <mat-option [value]="alertRule.code">
                  {{ alertRule.description }}
                </mat-option>
                }
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
          @if (!isFiltering) {
          <button [disabled]="filterForm.invalid" title="{{ 'alerts.form-button-filter-alert' | translate }}"
            class="btn btn-success" (click)="filterAlerts(null, null)">
            {{ "alerts.form-button-filter-alert" | translate }}
          </button>
          }
          @if (isFiltering) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
        }

        @if (isEditingAlert) {
        <app-alert-edit [editedAlert]="editedAlert" (editCancelation)="onCancelEdit($event)"
          (editAlert)="onEditAlert($event)"></app-alert-edit>
        }
      </div>
    </div>

    <!-- TABLE  -->
    @if (ELEMENT_DATA.length > 0) {
    <div class="col-lg-7 col-xl-8 col-sm-8">
      <app-table-header [showInfos]="false" [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData('CSV')"
        (downloadPDF)="generateFileData('PDF')" [loadingData$]="isFileLoading">
      </app-table-header>
      <div class="table-container mt-2 mt-lg-3">
        @if (length > 0) {
        <p-table [value]="ELEMENT_DATA" dataKey="id" [scrollable]="true" [scrollHeight]="'calc(100vh - 280px)'"
          [paginator]="true" (onPage)="pageChanged($event)" [rows]="pageSize" [totalRecords]="length"
          [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true" [first]="pageIndex">
          <ng-template pTemplate="header">
            <tr>
              <!-- alertas do sistema-->
              @if (!columnsEquipmentAlerts) {
              <th pSortableColumn="firstAlertDatetime" style="width: 12%">
                {{ "alerts.column-first-alert" | translate }}
              </th>
              <th pSortableColumn="lastAlertDatetime" style="width: 12%">
                {{ "alerts.column-last-alert" | translate }}
              </th>
              } @else {
              <!-- alertas do equipamento -->
              <th pSortableColumn="date" style="width: 12%">
                {{ "alerts.column-alert-date" | translate }}
              </th>
              }

              <th pSortableColumn="point" style="width: 10%">
                {{ "alerts.column-reference" | translate }}
              </th>
              <th pSortableColumn="latitude" style="width: 8%">
                {{ "alerts.column-latitude" | translate }}
              </th>
              <th pSortableColumn="longitude" style="width: 8%">
                {{ "alerts.column-longitude" | translate }}
              </th>

              @if (!columnsEquipmentAlerts) {
              <th pSortableColumn="rule" style="width: 22%">
                {{ "alerts.column-rule" | translate }}
              </th>
              <th pSortableColumn="status" style="width: 10%">
                {{ "alerts.column-status" | translate }}
              </th>
              <th pSortableColumn="actions" style="width: 8%">
                {{ "alerts.column-actions" | translate }}
              </th>
              } @else {
              <th pSortableColumn="route" style="width: 10%">
                {{ "alerts.column-gateway" | translate }}
              </th>
              <th pSortableColumn="device" style="width: 10%">
                {{ "alerts.column-equipment" | translate }}
              </th>
              <th pSortableColumn="eventCode" style="width: 20%">
                {{ "alerts.column-event-code" | translate }}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              @if (
              !columnsEquipmentAlerts
              ) {
              <td>{{ row.firstAlertDatetime }}</td>
              <td>{{ row.lastAlertDatetime }}</td>
              <td>{{ row.installation.reference }}</td>
              <td>{{ row.installation.latitude }}</td>
              <td>{{ row.installation.longitude }}</td>
              <td>{{ row.alertDescription }}</td>
              <td>{{ row.alertState }}</td>
              <td>
                @if (row.status != 'CLOSED' && !isEditingAlert) {
                <p-button icon="pi pi-cog" styleClass="btn-actions" [rounded]="true"
                  (click)="editAlert(row, row.installation)" />
                }
              </td>
              } @else {
              <td>{{ row.alertDatetime }}</td>
              <td>{{ row.reference }}</td>
              <td>{{ row.latitude }}</td>
              <td>{{ row.longitude }}</td>
              <td>
                {{ row.route }}
              </td>
              <td>
                {{ row.device }}
              </td>
              <td>
                <b>{{ row.eventCode.cod }}</b> -
                {{ row.eventCode.description }}
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
        }
      </div>
    </div>
    }
  </div>
</div>